<template>
  <div id="date-picker-container">
    <DatePicker
      inputReadOnly
      :showTime="timeDateRangeFormat"
      dropdownClassName=".datepicker-dropdown-layout"
      :format="dateRangePickerFormat"
      :placeholder="timeDateRangePlaceholder"
      :defaultValue="defaultDateRangeValue"
      @change="handleDateRange"
      @openChange="handleOpenChange"
    >
      <v-icon slot="suffixIcon" />
    </DatePicker>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import moment, { Moment } from 'moment';
import { DatePicker } from 'ant-design-vue';

import 'ant-design-vue/lib/date-picker/style/index.css';
import './styles/date-range-picker-component.scss';

@Component({
  components: {
    DatePicker: DatePicker.RangePicker
  }
})

export default class DateRangePickerComponent extends Vue {
  // Cannot convert this component in composition API, we get issues with defaultDateRangeValue and timeDateRangeFormat, we need to upgrade ant-design version
  @Prop({
    type: Array
  })
  private defaultDateRangeValue !: Moment[];

  private timeDateRangeFormat = {
    format: 'HH:mm',
    defaultValue: [
      moment('00:00:00', 'HH:mm:ss'),
      moment('23:59:59', 'HH:mm:ss')
    ]
  };

  private dateRangePickerFormat = 'DD/MM/YYYY HH:mm';

  private get timeDateRangePlaceholder() {
    return [this.$t('common.datetime.start'), this.$t('common.datetime.end')];
  }

  private handleDateRange(payload: Moment[]) {
    this.$emit('handleDateRange', payload);
  }

  private handleOpenChange(status: boolean) {
    if (!status) {
      this.$emit('query-device-history');
    }
  }
}
</script>
